<div class="card" *ngIf="viewModel$ | async as viewModel">
	<header>
		<h3>{{viewModel.header}}</h3>
		<div *ngIf="showDateTime">
			<span
				class="freya-link-button"
				(click)="store.dispatch(actions.rescheduleEventButtonClicked)"
				pTooltip="Reschedule"
			>{{ viewModel.event.datetime }} </span>
		</div>
	</header>
	<div class="p-fluid p-formgrid p-grid">
		<div class="p-field p-col-12 p-md-6">
			<label for="eventType">Event Type *</label>
			<p-dropdown
				id="eventType"
				[options]="eventTypes"
				[ngModel]="viewModel.eventType"
				(onChange)="store.dispatch(actions.eventTypeSelected({ eventType: $event.value }))"
				placeholder="Select event type"
				optionLabel="name"
				optionValue="value"
				appendTo="body"
			>
				<ng-template
					let-item
					pTemplate="item"
				>
					<div class="eventType">
						<span
							class="color"
							[style.backgroundColor]="item.backgroundColor"
						></span>
						<span>{{ item.name }}</span>
					</div>
				</ng-template>
				<ng-template
					let-selectedItem
					pTemplate="selectedItem"
				>
					<div class="eventType">
						<span
							class="color"
							[style.backgroundColor]="selectedItem.backgroundColor"
						></span>
						<span>{{ selectedItem.name }}</span>
					</div>
				</ng-template>
			</p-dropdown>
		</div>
		<div class="p-col-6"></div>
		<div class="p-field p-col-12 p-md-6">
			<label for="eventTitle">Event Title *</label>
			<input
				[ngModel]="viewModel.title"
				(ngModelChange)="store.dispatch(actions.eventTitleInputChanged({ eventTitle: $event }))"
				id="eventTitle"
				type="text"
				pInputText
			/>
		</div>
		<div class="p-field p-col-12 p-md-6">
			<label for="eventStatus">Status *</label>
			<p-dropdown
				id="eventStatus"
				[options]="eventStatus"
				[ngModel]="viewModel.status"
				(onChange)="store.dispatch(actions.eventStatusSelected({ status: $event.value }))"
				placeholder="Select event status"
				appendTo="body"
			></p-dropdown>
		</div>
		<div class="p-field p-col-12">
			<label for="assets">Assets</label>
			<p-autoComplete
				id="assets"
				[multiple]="true"
				[suggestions]="viewModel.assetSuggestions"
				[ngModel]="viewModel.assets"
				(onSelect)="store.dispatch(actions.assetSelected({ selectedAsset: $event.value }))"
				(onUnselect)="store.dispatch(actions.assetUnselected({ unselectedAsset: $event.value }))"
				(completeMethod)="store.dispatch(actions.assetAutocompleteSearchFired({ query: $event.query }))"
				field="name"
				appendTo="body"
				placeholder="Type asset name"
				appendTo="body"
			>
				<ng-template
					let-selectedItem
					pTemplate="selectedItem"
				>
					<div class="p-d-flex gap-2">
						<i class="pi pi-truck"></i>
						<span>{{ selectedItem.name }}</span>
					</div>
				</ng-template>
				<ng-template
					let-item
					pTemplate="item"
				>
					<div class="p-d-flex gap-2">
						<i class="pi pi-truck"></i>
						<span>{{ item.name }}</span>
					</div>
				</ng-template>
			</p-autoComplete>
		</div>
		<div class="p-field p-col-12">
			<h5>Locations</h5>
			<p-multiSelect
				display="chip"
				dataKey="addressLabel"
				optionLabel="addressLabel"
				[options]="viewModel.potentialEventLocations"
				[ngModel]="viewModel.locations"
				(onChange)="store.dispatch(actions.locationsSelectionChanged({ locations: $event.value }))"
				placeholder="Select locations"
				appendTo="body"
			></p-multiSelect>
		</div>
		<div
			class="p-field p-col-12 p-fluid p-formgrid p-grid"
			cdkDropList
			(cdkDropListDropped)="store.dispatch(actions.locationDropped({ previousIndex: $event.previousIndex, currentIndex: $event.currentIndex }))"
		>
			<div
				cdkDrag
				class="p-field p-col-12 p-fluid p-formgrid p-grid locationDetailsForm"
				*ngFor="let location of viewModel.locations; let i = index"
			>

				<div class="p-field p-col-6 locationDetails">
					<b> <i class="pi pi-map p-mr-2"></i> {{ location.type}} </b>
					<span> {{location.address }} </span>
				</div>
				<div class="p-field p-col-5">
					<label for="estimatedTimeAtLocation">Estimated time at location</label>
					<app-duration-input [duration]="location.estimatedTimeAtLocation" (durationChange)="store.dispatch(actions.locationDurationInputChanged({ locationType: location.type, duration: $event }))"></app-duration-input>
				</div>
				<div class="p-field p-col-1">
					<span class="dragHandle">
						<i class="pi pi-bars"></i>
					</span>
				</div>
			</div>
		</div>

		<div class="p-field p-col-12">
			<h5>Attendees</h5>
			<p-autoComplete
				id="crew"
				[multiple]="true"
				[suggestions]="viewModel.attendeeSuggestions"
				[ngModel]="viewModel.attendees"
				(onSelect)="store.dispatch(actions.attendeesSelected({ selectedAttendee: $event.value }))"
				(onUnselect)="store.dispatch(actions.attendeesUnselected({ unselectedAttendee: $event.value }))"
				(completeMethod)="store.dispatch(actions.attendeesAutocompleteSearchFired({ query: $event.query }))"
				field="name"
				appendTo="body"
				placeholder="Type crew name"
				appendTo="body"
			>
				<ng-template
					let-item
					pTemplate="item"
				>
					<div class="flex align-items-center gap-2">
						<div class="p-text-capitalize">{{item.name}} </div>
						<i
							class="pi pi-star-fill"
							*ngIf="item.role === 'Crew Lead'"
						></i>
					</div>

				</ng-template>
				<ng-template
					let-selectedItem
					pTemplate="selectedItem"
				>
					<div class="flex align-items-center gap-2">
						<div class="p-text-capitalize">{{selectedItem.name}} </div>
						<i
							class="pi pi-star-fill p-mr-2"
							*ngIf="selectedItem.role === 'Crew Lead'"
						></i>
					</div>
				</ng-template>
			</p-autoComplete>
		</div>
	</div>
	<div class="actionButtons">
		<p-button
			class="cancelButton"
			[outlined]="true"
			label="Cancel"
			icon="pi pi-times"
			(onClick)="store.dispatch(actions.closeCreateEventDialogButtonClicked())"
		></p-button>
		<!-- <p-button
				[disabled]="true"
				[outlined]="true"
				label="Create & Schedule"
				icon="pi pi-calendar"
				(onClick)="onClose()"
			></p-button> -->
		<p-button
			[loading]="viewModel.isLoading"
			[disabled]="viewModel.validationErrors.invalid"
			class="submitButton"
			label="{{viewModel.isEditMode ? 'Save': 'Create'}} Event"
			icon="pi pi-check"
			(click)="store.dispatch(actions.mutateEventButtonClicked())"
		></p-button>
	</div>
</div>
